var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("DropdownFilter", {
    attrs: {
      placeholder: "Enter document name",
      value: _vm.chosenDocuments,
      options: _vm.documents,
      loading: _vm.$apollo.queries.documents.loading,
      multiple: false,
    },
    on: { search: (v) => (_vm.searchString = v), input: _vm.handleInput },
    scopedSlots: _vm._u([
      {
        key: "singleLabel",
        fn: function ({ option }) {
          return [
            _c("MultiselectTag", {
              attrs: { option: option, single: "" },
              on: {
                remove: function ($event) {
                  return _vm.$emit("selectedRemoved")
                },
              },
            }),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }